import React from "react";
import { broadcast, GroupChatAvatarImg, SingleChatAvatarImg,
  ImgUserPlaceholder,Loader } from "../../assets/images";
import { useSelector } from "react-redux";
import IndexedDb from "../../Helpers/IndexedDb";
import { isSingleChat } from "../../Helpers/Chat/ChatHelper";
import { getInitialsFromName } from "../../Helpers/Utility";

const ImageComponent = React.memo(
  ({
    userToken = "",
    imageToken ="",
    fileKey = "",
    blocked = false,
    chatType ="chat",
    temporary =false,
    getImageUrl ="",
    onclickHandler ,
    imageType = "profileimages",
    name = "",
    ...props
  }) => {
    const globalState = useSelector(state => state)
    const { dynamicIcon = {} } = globalState;
    const { mf_ProfilePlaceholder , mf_GrpProfilePlaceholder } = dynamicIcon.data;
    
    const avatarIconObject = {
      chat: mf_ProfilePlaceholder ? mf_ProfilePlaceholder : SingleChatAvatarImg,
      groupchat: mf_GrpProfilePlaceholder ? mf_GrpProfilePlaceholder : GroupChatAvatarImg,
      broadcast: broadcast,
      loginProfile: ImgUserPlaceholder
    };
    
    const localDb = React.useMemo(() => new IndexedDb(), []);
    const [imgPointer, setImgPointer] = React.useState(false);
    const avatarIcon = chatType ? avatarIconObject[chatType] : avatarIconObject["chat"];
    // // const [initialsData, setInitialsData] = React.useState({ colorCode: "", inital: "" });
    const [showInitials, toggleInitials] = React.useState(false);
    const [getImage, saveImage] = React.useState(null);

    React.useEffect(() => {
      toggleInitials(false);
      let isSubscribed = true;
      if ((blocked || !imageToken) && isSubscribed){
        if (
          isSingleChat(chatType) && name && !blocked) {
          const initialName = getInitialsFromName(name);
          if (initialName) {
            toggleInitials(false);
            // // setInitialsData({ colorCode: getColorCodeInitials(name), inital: initialName });
          }
        }
        saveImage(null);
        return () => (isSubscribed = false);
      }

      if (/^(blob:http|blob:https):\/\//i.test(imageToken)) return saveImage(imageToken);
      // // if (new RegExp("^(blob:http|blob:https)://", "i").test(imageToken)) return saveImage(imageToken);


      localDb
        .getImageByKey(imageToken, imageType, fileKey)
        .then((blob) => {
          const blobUrl = window.URL.createObjectURL(blob);
          isSubscribed && saveImage(blobUrl);
        })
        .catch(() => {
          isSubscribed && saveImage(null);
          setImgPointer(true);
        });
      return () => (isSubscribed = false);
    },[name,imageToken, blocked])

    const onImageLoad = (event) => (event.target.style.backgroundImage = "");
    const checkNotFound = (event) => (event.target.src = avatarIcon);
    const addclass = props.classProps ? classNames(props.classProps) : null;
    const updatedUrl = getImage ? getImage : avatarIcon;
    React.useEffect(() => {
      if (getImageUrl) {
        getImageUrl(updatedUrl);
      }
    }, [updatedUrl]);

    
    if(showInitials && !blocked){
      return <SvgProfileName userShortName={initialsData.inital} initialColor={initialsData.colorCode} />;
    }
    
    return (
      <img
        src={updatedUrl}
        data-jest-id={"jestImageComponent"}
        style={{ backgroundImage: `url(${Loader})`, cursor: `${updatedUrl === avatarIcon ? "default" : ""}` }}
        onLoad={onImageLoad}
        className={`${addclass} ${props.caption === "" ? "no-caption" : ""} ${imgPointer ? "cursor-default" : ""}`}
        onError={checkNotFound}
        alt={""}
        onClick={updatedUrl !== avatarIcon ? onclickHandler : null}
      />
    );
  }
);

export default ImageComponent;
